import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonModal, ModalController, ToastController } from '@ionic/angular';
import { environment } from '../../../environment';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { AuthSession, fetchAuthSession } from 'aws-amplify/auth';
import { GlobalService } from '../services/global.service';
import { SendMessageModalComponent } from '../send-message-modal/send-message-modal.component';
import { Conversation } from 'infrastructure/lib/src/models/conversation';

@Component({
  selector: 'app-messages-modal',
  templateUrl: './messages-modal.component.html',
  styleUrls: ['./messages-modal.component.scss'],
})

export class MessagesModalComponent  implements OnInit {
  @ViewChild(IonModal) modal: IonModal;

  session: AuthSession;

  constructor(
    private http: HttpClient,
    public authenticator: AuthenticatorService,
    private modalCtrl: ModalController,
    private toastController: ToastController,
    public globalService: GlobalService
  ) { }

  async ngOnInit() {
    this.globalService.$loggedIn.subscribe({
      next: async loggedIn => {
        await this.requestConversationMetadata(loggedIn);
      },
      error : error => {
        console.error('There was an error retrieving logged in status!', error);
      }
    });
  }

  async requestConversationMetadata(loggedIn: boolean, displayErrorModal=true){
    if(loggedIn){
      this.session = await fetchAuthSession();
      this.http.get(`${environment.REST_API}/conversations`, {
              headers: new HttpHeaders({
                Authorization: `Bearer ${this.session.tokens.idToken}`
              }),
      }).subscribe({
        next: data => {
          GlobalService.$conversationsMetadata.next(data["conversations"] as Array<Conversation>);
        },
        error: async error => {
          console.error('There was an error retrieving your conversations!', error);
          if(displayErrorModal){
            const toast = await this.toastController.create({
              message: `There was an error retrieving your conversations.`,
              duration: 2000,
              color: 'danger',
              position: 'top',
            });
            await toast.present();
          }
        }
      });
    }
  }

  openSendMessageModal(conversation: Conversation){
    const recipient = this.determineRecipient(conversation);
    GlobalService.incrementModalCount();
    this.modalCtrl.create({
      component: SendMessageModalComponent,
      componentProps: {
        recipient: recipient
      }
    }).then((modal) => {
      modal.present();
      modal.onDidDismiss().then(() => {
        GlobalService.decrementModalCount();
      });
    });
  }

  getConversationsMetadata(){
    return GlobalService.$conversationsMetadata;
  }

  determineRecipient(conversation: Conversation){
    return conversation.userA === GlobalService.$currentUser.value.username ? conversation.userB : conversation.userA;
  }

  hasUnreadMessages(conversation: Conversation){
    return conversation.userA === GlobalService.$currentUser.value.username ? conversation.lastViewedByA < conversation.lastMessageTimestamp : conversation.lastViewedByB < conversation.lastMessageTimestamp;
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

}
